import React from "react";
import PropTypes from "prop-types";
import { Link as RouterLink, withRouter } from "react-router-dom";
import isApp from "shared/util/isApp";

const Link = ({ history, to, onClick, className, children }) => {
	const handleClick = () => {
		onClick();

		if (isApp()) {
			history.push(to);
		}
	};

	if (isApp()) {
		return (
			<button
				type="button"
				className={className}
				onClick={handleClick}
			>
				{children}
			</button>
		);
	} else {
		return (
			<RouterLink
				className={className}
				to={to}
				type="button"
				onClick={handleClick}
			>
				{children}
			</RouterLink>
		);
	}
};

Link.propTypes = {
	history: PropTypes.object.isRequired,
	to: PropTypes.string.isRequired,
	onClick: PropTypes.func,
	children: PropTypes.any,
	className: PropTypes.string,
};

Link.defaultProps = {
	onClick: () => {},
	children: null,
	className: "",
};

export default withRouter(Link);



// WEBPACK FOOTER //
// ./src/shared/components/Link.jsx